import * as React from "react";
import type { SVGProps } from "react";
const SvgCreditcardCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#creditcard-check_svg__a)">
      <path d="M13.5 20h-8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v4a1 1 0 0 1-2 0V8a2 2 0 0 0-2-2h-12a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a1 1 0 0 1 0 2" />
      <path d="M20.5 11h-18a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2M6.5 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2M12.5 16h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2M18 21a1 1 0 0 1-.8-.4l-1.5-2a1 1 0 0 1 1.6-1.2l.67.9 2.71-3.87a1 1 0 0 1 1.64 1.14l-3.5 5a1 1 0 0 1-.8.43z" />
    </g>
    <defs>
      <clipPath id="creditcard-check_svg__a">
        <path fill="#fff" d="M1.5 4h21v17h-21z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCreditcardCheck;
